<template>
  <VModal ref="modal" @close="$emit('hide')">
    <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-lg sm:w-full">
      <BaseCard>
        <BaseCardHeader> Add Media </BaseCardHeader>
        <BaseCardBody>
          <FileUpload
            :options="{
              allowMultiple: true,
              acceptedFileTypes,
            }"
            v-model="formData.media"
          />
        </BaseCardBody>
        <BaseCardFooter>
          <div class="flex space-x-2">
            <BaseButton
              v-if="formData.media.length"
              type="button"
              primary
              :disabled="loading"
              class="w-full"
              @click="storeMedia"
            >
              Save
            </BaseButton>
            <BaseButton type="button" primary outline :disabled="loading" @click="close">
              Cancel
            </BaseButton>
          </div>
        </BaseCardFooter>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import FileUpload from 'Components/FileUpload/Index.vue';
import { accProductMediaClient } from '@/api/clients';

export default {
  components: {
    FileUpload,
  },
  props: {
    accProductId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      formData: {
        media: [],
      },
      acceptedFileTypes: ['image/*'],
    };
  },
  methods: {
    close() {
      this.$refs.modal.close();
    },
    async storeMedia() {
      try {
        this.loading = true;

        await accProductMediaClient.store(this.accProductId, this.formData);

        this.formData.media = [];

        this.$emit('saved');

        this.close();

        this.loading = false;
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
